export const cartClassName = [
  'vst-btn--large-full-width',
  'vst-btn--orange',
  'add_to_cart'
].join(' ')
